import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "17",
  viewBox: "0 0 18 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = {
  key: 0,
  d: "M 8.8199257,15.751368 1.4088872,12.629988",
  stroke: "#64e1a5",
  "stroke-width": "2",
  id: "path2"
}
const _hoisted_3 = {
  key: 1,
  d: "m 9.7778394,15.685997 7.5290666,-2.84657",
  stroke: "#64e1a5",
  "stroke-width": "2",
  id: "path4692"
}
const _hoisted_4 = {
  key: 2,
  style: {"fill":"none"},
  id: "g4737",
  transform: "translate(15.16016,4.0338983)"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("path", {
      d: "M 9.08621,5.68208 V 16 m 0,-10.31792 L 1.49219,3.25434 M 9.08621,5.68208 17.0462,3.25434 M 9.08621,16 1.67518,12.8786 1.49219,3.25434 M 9.08621,16 17.0462,12.8786 V 3.25434 m -15.55401,0 L 9.08621,1 17.0462,3.25434",
      stroke: "#505c8e",
      id: "path4592"
    }, null, -1)),
    (_ctx.dimension === 'length')
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.dimension === 'width')
      ? (_openBlock(), _createElementBlock("path", _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.dimension === 'height')
      ? (_openBlock(), _createElementBlock("g", _hoisted_4, _cache[0] || (_cache[0] = [
          _createElementVNode("path", {
            d: "M 1.83984,0 V 8.5",
            stroke: "#64e1a5",
            "stroke-width": "2",
            id: "path4728"
          }, null, -1)
        ])))
      : _createCommentVNode("", true)
  ]))
}